import React, { useState, useEffect } from "react";

import "./WeatherForecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";


export default function WeatherForecast(props) {
    let [loaded, setLoaded] = useState(false);
    let [forecast, setForecast] = useState(null);

    useEffect(() => {
setLoaded(false);
    }, [props.coordinates]);




    function handleResponse(response) {
    
        setForecast(response.data.list);
        setLoaded(true);
    }

    function load() {
        let longitude = props.coordinates.lon;
        let latitude = props.coordinates.lat;
      let apiUrl= `https://api.openweathermap.org/data/2.5/forecast?lat=${latitude}&lon=${longitude}&appid=20b53919a21c5e6c903732f960015f82&units=metric`;
        
      
      axios.get(apiUrl).then(handleResponse);

    }
    
    if (loaded) {
      
        return (
            <div className="WeatherForecast">
                <div className="row">
                    <div className="col">

                        <WeatherForecastDay data ={forecast[0]} />

                    </div>
                    <div className="col">

<WeatherForecastDay data ={forecast[8]} />

</div>
<div className="col">

<WeatherForecastDay data ={forecast[16]} />

</div>

<div className="col">

<WeatherForecastDay data ={forecast[24]} />

</div>
<div className="col">

<WeatherForecastDay data ={forecast[32]} />

</div>

                </div>
            </div>
        );
    
    } else {
      load();
      return null;
    }
}